import styled from '@emotion/styled'
import { ExtranetContainer, MediaQuery, useBreakpoint, useLanguage } from '@pharmac-extranet/shared'
import { PharmacButton, PharmacIcon, PharmacMainLogoMono, PharmacText } from '@pharmac/ui'
import { useNavigate } from 'react-router-dom'
import {
  __ORDER_AND_DELIVERY_TERMS_LINK,
  __PRIVACY_POLICY_LINK,
  __TERMS_OF_USE_LINK,
} from '../../constants'
import { useExtranetPath } from '../../router/useExtranetPath'

const ExtranetFooterRoot = styled.div`
  width: 100%;
  background-color: var(--color-primary);
  margin-top: auto;
`

const FooterWrapper = styled.div`
  width: var(--extranet-wrapper-width);
  margin: var(--spacing-small) auto;

  ${MediaQuery.maxTablet} {
    margin: 0;
    width: 100%;
  }
`

const ExtranetFooterInner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: var(--spacing-large) 0;

  ${MediaQuery.maxTablet} {
    flex-direction: column;
    align-items: center;
    padding: 15%;
  }
`

const FooterContenContainer = styled(ExtranetContainer)`
  ${MediaQuery.maxTablet} {
    width: 85%;
  }
`

const FooterTitle = styled(PharmacText)`
  font-size: 18px;
  color: white;
  font-weight: bold;
`

const ContactButtonText = styled(PharmacText)`
  font-size: 16px;
  font-weight: bold;
`

const FooterText = styled(PharmacText)`
  font-size: 16px;
  color: white;
  margin-top: var(--spacing-tiny);
  font-weight: 500;
`

const FooterLink = styled.a`
  font-family: var(--typo-text-font-family);
  font-size: 16px;
  color: white;
  margin-top: var(--spacing-tiny);
  font-weight: 500;
`

const FooterIconLink = styled.a`
  width: 24px;
  height: 24px;
  margin-right: var(--spacing-small);
`

export const ExtranetFooter = () => {
  const { t } = useLanguage()
  const { maxTablet } = useBreakpoint()
  const navigate = useNavigate()
  const createLink = useExtranetPath()

  return (
    <ExtranetFooterRoot>
      <FooterWrapper>
        <ExtranetFooterInner>
          <FooterContenContainer
            alignCenter
            flexColumn
          >
            <PharmacMainLogoMono
              width={maxTablet ? '100%' : '175px'}
              color="white"
            />

            <PharmacButton
              marginLargeTop
              variant="secondary"
              onClick={() => navigate(createLink('support.contact'))}
            >
              <ContactButtonText>{t('footer.contact')}</ContactButtonText>
              <PharmacIcon
                style={{ marginLeft: 'var(--spacing-tiny)' }}
                icon="send"
                size="20"
              />
            </PharmacButton>
          </FooterContenContainer>
          <FooterContenContainer
            flexColumn
            marginLargeTop={maxTablet}
          >
            <FooterTitle marginMediumBottom>Pharmac Finland Oy</FooterTitle>
            <FooterText>Rajatorpantie 41 C,</FooterText>
            <FooterText>01640 Vantaa</FooterText>
            <FooterText>1867730-0</FooterText>
            <FooterLink
              target="_blank"
              href="https://www.pharmac.fi/"
            >
              https://www.pharmac.fi/
            </FooterLink>
          </FooterContenContainer>
          <FooterContenContainer
            flexColumn
            marginLargeTop={maxTablet}
          >
            <FooterTitle marginMediumBottom>{t('footer.links')}</FooterTitle>
            <FooterLink
              target="_blank"
              href={__PRIVACY_POLICY_LINK}
            >
              {t('footer.privacyPolicy')}
            </FooterLink>
            <FooterLink
              target="_blank"
              href={__TERMS_OF_USE_LINK}
            >
              {t('footer.termsOfUse')}
            </FooterLink>
            <FooterLink
              target="_blank"
              href={__ORDER_AND_DELIVERY_TERMS_LINK}
            >
              {t('footer.shopTermsAndConditionsOfContractAndDelivery')}
            </FooterLink>
            <FooterLink
              target="_blank"
              href="https://www.pharmac.fi/wp-content/uploads/oivaraportti_236656-18-9-2025.pdf"
            >
              {t('footer.oivaReport')}
            </FooterLink>
          </FooterContenContainer>
          <FooterContenContainer
            marginLargeTop={maxTablet}
            justifyCenter={maxTablet}
          >
            <FooterIconLink
              target="_blank"
              href="https://www.facebook.com/PharmacFinlandOy/?locale=fi_FI"
            >
              <PharmacIcon
                icon="facebook2"
                stroke="none"
                fill="white"
                size="24px"
              />
            </FooterIconLink>
            <FooterIconLink
              target="_blank"
              href="https://www.instagram.com/pharmac_finland_oy/"
            >
              <PharmacIcon
                icon="instagram"
                stroke="white"
                size="24px"
              />
            </FooterIconLink>
            <FooterIconLink
              target="_blank"
              href="https://www.linkedin.com/company/pharmacfinlandoy/?originalSubdomain=fi"
            >
              <PharmacIcon
                icon="linkedin2"
                stroke="none"
                fill="white"
                size="24px"
              />
            </FooterIconLink>
          </FooterContenContainer>
        </ExtranetFooterInner>
      </FooterWrapper>
    </ExtranetFooterRoot>
  )
}
